function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 22.0003,
  r: 15.2727,
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2122 28.991L27.2122 28.991C27.3988 29.1856 27.6922 29.1857 27.8789 28.991L27.2122 28.991ZM27.2122 28.991L20.8304 22.3348C20.6324 22.1283 20.6324 21.7851 20.8304 21.5786C20.8304 21.5786 20.8304 21.5786 20.8304 21.5786L22.2188 20.1304L22.2188 20.1304C22.4054 19.9358 22.6989 19.9358 22.8855 20.1304L22.8855 20.1304L27.1846 24.6143L27.5455 24.9908L27.9064 24.6143L37.1146 15.0102C37.3012 14.8156 37.5947 14.8156 37.7813 15.0102L39.1698 16.4584L39.5286 16.1144L39.1698 16.4584C39.3677 16.6649 39.3678 17.008 39.1698 17.2146C39.1698 17.2146 39.1698 17.2146 39.1698 17.2146L27.8789 28.991L27.2122 28.991Z",
  fill: "#FF8D10",
  stroke: "#FF8D10"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: 0.727295,
  y: 0.727539,
  width: 58.5455,
  height: 50.5455,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.160784 0 0 0 0 0.176471 0 0 0 0 0.184314 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

const SvgSuccessCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 52,
  viewBox: "0 0 60 52",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success-circle.f279d8a7.svg";
export { ForwardRef as ReactComponent };